// Add your custom JS here.

/*
let originalTitle = document.title;

document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
        document.title = "Vous nous quittez déjà ?";
    } else {
        // Restaurer le titre original
        document.title = originalTitle;
    }
});
*/


document.addEventListener('DOMContentLoaded', function () {

    if (document.body.classList.contains('home')) {
        var swiper = new Swiper('#reassurance', {
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 3000,
            allowTouchMove: false,
            slidesPerView: 'auto',
        });
    };

});


jQuery(document).ready(function($) {
    // Fonction pour ajouter les boutons moins et plus
    function addQuantityButtons() {
        $('.quantity input[type="number"]').each(function() {
            var $quantityInput = $(this);
            if (!$quantityInput.closest('.quantity-wrapper').length) {
                $quantityInput.wrap('<div class="quantity-wrapper"></div>');
                $quantityInput.before('<input type="button" value="-" class="minus">');
                $quantityInput.after('<input type="button" value="+" class="plus">');
            }
        });
    }

    // Fonction pour obtenir une valeur numérique valide
    function getValidNumber(value) {
        var num = parseInt(value);
        return isNaN(num) ? 0 : num;
    }

    // Gérer le clic sur le bouton moins
    $(document).on('click', '.minus', function() {
        var $input = $(this).siblings('input[type="number"]');
        var minValue = parseInt($input.attr('min')) || 0;
        var currentValue = getValidNumber($input.val());
        var newValue = currentValue - 1;
        if (newValue >= minValue) {
            $input.val(newValue);
        } else {
            $input.val(minValue);
        }
        $input.trigger('change');
        return false;
    });

    // Gérer le clic sur le bouton plus
    $(document).on('click', '.plus', function() {
        var $input = $(this).siblings('input[type="number"]');
        var maxValue = parseInt($input.attr('max')) || Infinity;
        var currentValue = getValidNumber($input.val());
        var newValue = currentValue + 1;
        if (newValue <= maxValue) {
            $input.val(newValue);
        } else {
            $input.val(maxValue);
        }
        $input.trigger('change');
        return false;
    });

    // Initialiser les boutons
    addQuantityButtons();

    // Utiliser MutationObserver pour observer les changements dans le DOM
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                addQuantityButtons();
            }
        });
    });

    // Configurer l'observateur pour observer les changements dans le body
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});




document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.term-description').forEach(function (desc) {
    if (desc.scrollHeight > desc.clientHeight) {
      const btn = document.createElement('span');
      btn.className = 'term-description-toggle';
      btn.textContent = 'Lire la suite';
      btn.addEventListener('click', function () {
        desc.classList.toggle('expanded');
        btn.textContent = desc.classList.contains('expanded') ? 'Réduire' : 'Lire la suite';
      });
      desc.appendChild(btn);
    }
  });
});